exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.file-tree-browser-toggle-wrapper[data-v-0a3c199d] {\n  display: contents; /* Removes wrapper from layout flow */\n}\n", ""]);

